/**
 * Generate Linkedin Share URL
 * @param  {string} [url='']     url to share
 * @param  {string} [title='']   title of share
 * @param  {string} [summary=''] summary of share
 * @param  {string} [source='']  source of share
 * @return {string}              share link
 */
export default function linkedinShare(
  url = '',
  title = '',
  summary = '',
  source = ''
) {
  return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}&source=${encodeURIComponent(source)}`;
}



// WEBPACK FOOTER //
// ./app/services/share/linkedin.js